export default [
  {
    title: '超大文字H1',
    description: '建议用法：适用于超大屏幕，Banner文案，适度使用。',
    size: '38px',
    basic: [
      {
        name: '基本属性',
        fontSize: 'Font-size : 38px',
        fontWeight: 'Font-weight ： 500 / Medium',
        color: 'Color: #000000',
        opacity: 'Opacity: 0.8'
      }
    ],
    ui: [
      {
        name: 'UI属性',
        lineHeight: 'Line-height : 46px',
        MarginTop: 'Margin-top: 56px'
      }
    ]
  },
   {
    title: '标题文字H2',
    description: '建议用法：适用于空状态和功能介绍，顶级标题。',
    size: '30px',
    basic: [
      {
        name: '基本属性',
        fontSize: 'Font-size : 30px',
        fontWeight: 'Font-weight ： 500 / Medium',
        color: 'Color: #000000',
        opacity: 'Opacity: 0.8'
      }
    ],
    ui: [
      {
        'name': 'UI属性',
        'lineHeight': 'Line-height : 38px',
        'MarginTop': 'Margin-top: 48px'
      }
    ]
  },
  {
    title: '超大文字H3',
    description: '建议用法：适用于页面标题，每页只用一次。',
    size: '24px',
    basic: [
      {
        name: '基本属性',
        fontSize: 'Font-size : 24px',
        fontWeight: 'Font-weight ： 500 / Medium',
        color: 'Color: #000000',
        opacity: 'Opacity: 0.8'
      }
    ],
    ui: [
      {
        name: 'UI属性',
        lineHeight: 'Line-height : 32px',
        MarginTop: 'Margin-top: 40px'
        }
      ]
    },
    {
      title: '超大文字H4',
      description: '建议用法：适用于标识关键功能的标题，模块标题。',
      size: '20px',
      basic: [
        {
          name: '基本属性',
          fontSize: 'Font-size : 20px',
          fontWeight: 'Font-weight ： 500 / Medium',
          color: 'Color: #000000',
          opacity: 'Opacity: 0.8'
        }
      ],
      ui: [
        {
          name: 'UI属性',
          lineHeight: '28px',
          MarginTop: 'Margin-top: 32px'
        }
      ]
    },
    {
      title: '标题文字H5',
      description: '建议用法：适用于段落和字段组标题。',
      size: '16px',
      basic: [
        {
          name: '基本属性',
          fontSize: 'Font-size : 16px',
          fontWeight: 'Font-weight ： 500 / Medium',
          color: 'Color: #000000',
          opacity: 'Opacity: 0.8'
        }
      ],
      ui: [
        {
          name: 'UI属性',
          lineHeight: 'Line-height : 24px',
          MarginTop: 'Margin-top: 24px'
        }
      ]
    },
    {
      title: '标题文字H6',
      description: '建议用法：适用于层级较深的标题，或突出显示重要信息，表格的标题。',
      size: '14px',
      basic: [
        {
          name: '基本属性',
          fontSize: 'Font-size : 14px',
          fontWeight: 'Font-weight ： 500 / Medium',
          color: 'Color: #000000',
          opacity: 'Opacity: 0.8'
        }
      ],
      ui: [
        {
          name: 'UI属性',
          lineHeight: 'Line-height : 22px',
          MarginTop: 'Margin-top: 24px'
        }
      ]
    },
    {
      title: '正文文字（大号）',
      description: '建议用法：适用于大尺寸的组件中的文本，比如按钮、进度条等。',
      size: '16px',
      basic: [
        {
          name: '基本属性',
          fontSize: 'Font-size : 16px',
          fontWeight: 'Font-weight ： 400 / Regular',
          color: 'Color: #000000',
          opacity: 'Opacity: 0.6'
        }
      ],
      ui: [
        {
          name: 'UI属性',
          lineHeight: 'Line-height : 22px',
          MarginTop: 'Margin-top: 16px'
        }
      ]
    },
    {
      title: '正文文字（主字号）',
      description: '建议用法：适用于正文文字。',
      size: '14px',
      basic: [
        {
          name: '基本属性',
          fontSize: 'Font-size : 14px',
          fontWeight: 'Font-weight ： 400 / Regular',
          color: 'Color: #000000',
          opacity: 'Opacity: 0.8'
        }
      ],
      ui: [
        {
          name: 'UI属性',
          lineHeight: 'Line-height : 22px',
          MarginTop: 'Margin-top: 24px'
        }
      ]
    },
    {
      title: '正文字体（小号）',
      description: '建议用法：适用于表单字段下的帮助文本和应用程序中的辅助支持文本，应谨慎使用。',
      size: '12px',
      basic: [
        {
          name: '基本属性',
          fontSize: 'Font-size : 12px',
          fontWeight: 'Font-weight ： 400 / Regular',
          color: 'Color: #000000',
          opacity: 'Opacity; 0.6'
        }
      ],
      ui: [
        {
          name: 'UI属性',
          lineHeight: 'Line-height : 20px',
          MarginTop: 'Margin-top: 8px'
        }
      ]
    },
    {
      title: '段落文字P',
      description: '建议用法：适用于常规段落文字。',
      size: '14px',
      basic: [
        {
          name: '基本属性',
          fontSize: 'Font-size : 14px',
          fontWeight: 'Font-weight ： 400 / Regular',
          color: 'Color: #000000',
          opacity: 'Opacity: 0.6'
        }
      ],
      ui: [
        {
          name: 'UI属性',
          lineHeight: 'Line-height : 22px',
          MarginTop: 'Margin-top: 24px',
          LetterSpacing: 'Letter-spacing: 0.5px'
        }
      ]
    },
  ]
